import { useTranslation } from "react-i18next";
import { RequestsPanel } from "@/components/RequestsPanel";

export default function Requests() {
  const { t } = useTranslation();
  return (
    <div className="space-y-4" data-testid="requests-page">
      <div>
        <h1 className="font-display text-3xl font-extrabold">{t("Requests & Feedback")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("Need something KlenaPro doesn't do yet, or want a change? Send it here with screenshots or files — during your trial and any time after. The developer replies in this thread.")}
        </p>
      </div>
      <RequestsPanel />
    </div>
  );
}
